import Grid from '@mui/material/Grid';
import { errorMessage } from 'constants/CommonConstants';
import { dataFormat, dobValidationRule, formRequiredRules } from 'helper';
import React, { useImperativeHandle } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { DateInput } from 'sharedComponents/inputGroup';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { StepperFromProps } from 'sharedComponents/dynamicStepperForm/dynamicStepperFormInterface';
import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import { postLeadCreation } from 'store/LeadCreationState';
import { Lead } from '../LeadGenInterface';

const Dob: React.ForwardRefRenderFunction<unknown, StepperFromProps> = (
  { onNext, onBack, isSubmit, mappedData },
  ref
) => {
  // Hooks
  const { t } = useTranslation();

  const hasCalledNextStep = React.useRef(false);

  // React Hook Form
  const { control, trigger, getValues } = useFormContext();

  // Redux State
  const dispatch: ThunkDispatch<RootState, AnyAction, AnyAction> = useDispatch();

  const { authenticateClientData } = useSelector((state: RootState) => state.auth) || {};
  const widgetData = authenticateClientData?.data?.widgetData || {};

  // React Hook Form Trigger
  const nextStep = () => {
    if (hasCalledNextStep.current) return;
    hasCalledNextStep.current = true;

    const { dateOfBirth } = getValues();

    const dobData: Lead = {
      birthDate: dataFormat(dateOfBirth, 'yyyy-MM-dd'),
      leadSourceId: widgetData?.leadSourceId,
      isSubmit,
      leadDetails: {
        'Date Of Birth': dataFormat(dateOfBirth, 'yyyy-MM-dd'),
        ...mappedData,
      },
    };

    dispatch(postLeadCreation({ data: dobData, leadTypeID: widgetData?.leadTypeId })).then((res) => {
      if (
        res?.payload?.success &&
        (res?.payload?.data?.draftLeadId || res?.payload?.data?._id || res?.payload?.data?.Lead?.leadId)
      ) {
        onNext?.();
      }
    });
  };

  const backStep = () => {
    onBack?.();
  };
  useImperativeHandle(ref, () => ({
    nextStep,
    backStep,
  }));

  return (
    <Grid container justifyContent={{ xs: 'center' }}>
      <Grid item xs={12} lg={9}>
        <h3 className='dy-stepper-form__body__title text-center'>{t('leadGen.dobTxt')}</h3>
        <Grid container justifyContent={{ xs: 'center' }} rowSpacing={3} columnSpacing={2}>
          <Grid item lg={10} sm={8} xs={12}>
            <DateInput
              name='dateOfBirth'
              control={control}
              label={t('leadGen.dob')}
              rules={{
                ...formRequiredRules(errorMessage(t).dobRequired),
                ...dobValidationRule(errorMessage(t).ageValidation),
              }}
              triggerValidationForField={trigger}
              maxDate={new Date(new Date().setFullYear(new Date().getFullYear() - 18))}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

const DobStep = React.forwardRef(Dob);

export default DobStep;
